export const checkFileType = (allowedExtensions: string[], fileType: string): boolean => {
	return allowedExtensions.includes(fileType.toLowerCase());
};
